const actions = {
  SET_FOOTER_DISCLAIMER (val) {
    this.footerDisclaimer = val
  },
  changeFooterDisclaimer (value = null) {
    this.SET_FOOTER_DISCLAIMER(value)
  }
}
export default actions
